import React from "react";
import { Clock, Edit, MapPin } from "lucide-react";

const TYPE_COLOR_CLASS = {
  worship: "from-white/95 to-purple-50/90 border-purple-100/50 text-purple-600",
  event: "from-white/95 to-orange-50/90 border-orange-100/50 text-orange-600",
  meeting: "from-white/95 to-blue-50/90 border-blue-100/50 text-blue-600",
  fellowship: "from-white/95 to-teal-50/90 border-teal-100/50 text-teal-600",
};

export default function ScheduleCardItem({
  fireIconSrc,
  getDepartmentColor,
  getTypeIcon,
  getTypeName,
  onOpenDetail,
  schedule,
  selectedDepartment,
}) {
  const activeColorClass = TYPE_COLOR_CLASS[schedule.type] || "from-white/95 to-gray-50/90 border-gray-100/50 text-gray-600";

  return (
    <div
      onClick={() => onOpenDetail(schedule)}
      className={`
        group relative overflow-hidden rounded-[2rem] p-6 cursor-pointer transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl
        bg-gradient-to-br ${activeColorClass}
        backdrop-blur-2xl border shadow-lg ring-1 ring-white/50
      `}
    >
      <div className="absolute -right-6 -top-6 w-32 h-32 bg-white/40 rounded-full blur-2xl transition-all group-hover:scale-150 duration-700"></div>

      <div className="relative z-10 flex flex-col h-full justify-between gap-4">
        <div className="flex justify-between items-start">
          <span className="text-xs font-bold text-gray-400 bg-white/50 px-3 py-1 rounded-full backdrop-blur-sm shadow-sm border border-white/50">
            {schedule.date.slice(5)}
          </span>
          <div className="flex items-center gap-1">
            {schedule.priority === "high" && <img src={fireIconSrc} className="w-5 h-5 animate-pulse" alt="urgent" />}
            <span className="text-[10px] font-black px-2.5 py-1 rounded-lg shadow-sm bg-white/80">
              {getTypeName(schedule.type)}
            </span>
          </div>
        </div>

        {selectedDepartment === "All" && (
          <div className="absolute top-2 right-2 z-20">
            <span className={`text-[10px] font-bold text-white px-2.5 py-1 rounded-full border border-white/20 shadow-md backdrop-blur-md ${getDepartmentColor(schedule.department || "All")}`}>
              {schedule.department === "All" || !schedule.department ? "전체" : schedule.department}
            </span>
          </div>
        )}

        <div className="flex flex-col items-center text-center gap-2">
          <div className="w-16 h-16 relative">
            <div className="absolute inset-0 bg-white/30 rounded-full blur-xl animate-pulse-slow"></div>
            <img
              src={getTypeIcon(schedule.type)}
              alt={schedule.type}
              className={`w-full h-full object-contain drop-shadow-md transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6 ${schedule.isCompleted ? "grayscale opacity-50" : ""}`}
            />
          </div>
          <h4 className={`font-bold text-gray-700 text-lg line-clamp-1 w-full px-2 ${schedule.isCompleted ? "line-through opacity-50" : ""}`}>
            {schedule.title}
          </h4>
        </div>

        <div className="mt-auto pt-4 border-t border-black/5 flex flex-col gap-1 items-center justify-center">
          {schedule.startTime && (
            <div className="flex items-center gap-1.5 text-xs font-bold text-gray-500">
              <Clock size={12} className="opacity-70" />
              <span>{schedule.startTime} {schedule.endTime && `~ ${schedule.endTime}`}</span>
            </div>
          )}
          {schedule.location && (
            <div className="flex items-center gap-1.5 text-xs font-bold text-gray-400">
              <MapPin size={12} className="opacity-70" />
              <span>{schedule.location}</span>
            </div>
          )}
        </div>
      </div>

      <div className="absolute inset-0 z-50 bg-black/5 backdrop-blur-[1px] opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-start justify-center pt-8 pointer-events-none">
        <div className="bg-white/95 text-gray-800 px-4 py-2 rounded-full font-bold shadow-xl transform -translate-y-4 group-hover:translate-y-0 transition-transform duration-300 flex items-center gap-2 border border-white/50">
          <Edit size={16} /> 상세보기
        </div>
      </div>
    </div>
  );
}
